/*
 * vg-whatsapp-consult.js — Victoria's Gala
 * Two button classes:
 *   .vg-wa-consult — "Consultar por WhatsApp" (asesoría)
 *   .vg-wa-buy     — "Comprar por WhatsApp" (intención de compra, incluye URL)
 * Both read selected Color + Talla from <variant-picker>.
 */
(function () {
  'use strict';

  var PHONE = '51944580534';

  // Pre-encoded templates so emojis survive
  var CONSULT_START = 'Hola%20%F0%9F%92%95%20estoy%20interesada%20en%20el%20modelo%20';
  var CONSULT_MID1  = '%20en%20color%20';
  var CONSULT_MID2  = '%2C%20talla%20';
  var CONSULT_END   = '.%20%C2%BFMe%20pueden%20confirmar%20disponibilidad%20y%20ayudarme%20con%20la%20compra%3F%20%E2%9C%A8';

  // Buy template: "Hola, estoy interesada en este vestido. Modelo: X. Color: Y. Talla: Z. Link: URL. ¿Me podrían confirmar disponibilidad?"
  var BUY_START = 'Hola%2C%20estoy%20interesada%20en%20este%20vestido.%20Modelo%3A%20';
  var BUY_MID1  = '.%20Color%3A%20';
  var BUY_MID2  = '.%20Talla%3A%20';
  var BUY_MID3  = '.%20Link%3A%20';
  var BUY_END   = '.%20%C2%BFMe%20podr%C3%ADan%20confirmar%20disponibilidad%3F';

  function textWithoutChildren(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    var kids = clone.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) kids[i].remove();
    return (clone.textContent || '').trim();
  }

  function getProductTitle(link) {
    if (link && link.closest) {
      var container = link.closest('product-information, [class*="product-information"], [class*="product-details"]');
      if (container) {
        var h1 = container.querySelector('h1');
        var t = h1 && h1.textContent.trim();
        if (t) return t;
      }
    }
    var picker = document.querySelector('variant-picker');
    if (picker && picker.closest) {
      var pctx = picker.closest('product-information, [class*="product-information"], [class*="product-details"], main');
      if (pctx) {
        var ph1 = pctx.querySelector('h1');
        var pt = ph1 && ph1.textContent.trim();
        if (pt) return pt;
      }
    }
    var og = document.querySelector('meta[property="og:title"]');
    if (og && og.content) return og.content.split(/\s+[–—\-|]\s+/)[0].trim();
    if (document.title) return document.title.split(/\s+[–—\-|]\s+/)[0].trim();
    return 'este modelo';
  }

  function readVariantOptions(picker) {
    var opts = {};
    if (!picker) return opts;
    var fieldsets = picker.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = fs.querySelector('legend');
      var name = textWithoutChildren(legend);
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (name && checked && checked.value) opts[name] = checked.value;
    }
    var selects = picker.querySelectorAll('select.variant-option__select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var match = sel.name && sel.name.match(/options\[(.+)\]/);
      var selName = match ? match[1] : null;
      if (selName && sel.value) opts[selName] = sel.value;
    }
    return opts;
  }

  function findOption(opts, candidates) {
    var keys = Object.keys(opts);
    for (var i = 0; i < candidates.length; i++) {
      var want = candidates[i].toLowerCase();
      for (var j = 0; j < keys.length; j++) {
        if (keys[j].toLowerCase() === want) return opts[keys[j]];
      }
    }
    return null;
  }

  function handleClick(ev, link, type) {
    ev.preventDefault();

    var picker = (link.closest && link.closest('product-information, [class*="product-information"]') || document).querySelector('variant-picker');
    var opts = readVariantOptions(picker);

    var color = findOption(opts, ['Color', 'Colour']);
    var size = findOption(opts, ['Talla', 'Size', 'Tamaño', 'Tamano']);

    if (!color && !size) {
      window.alert('Por favor selecciona un color y una talla antes de continuar.');
      return;
    }
    if (!color) {
      window.alert('Por favor selecciona un color antes de continuar.');
      return;
    }
    if (!size) {
      window.alert('Por favor selecciona una talla antes de continuar.');
      return;
    }

    var title = getProductTitle(link);
    var url;

    if (type === 'buy') {
      // Include product URL in the message
      var productUrl = window.location.origin + window.location.pathname;
      var encoded = BUY_START + encodeURIComponent(title) +
                    BUY_MID1  + encodeURIComponent(color) +
                    BUY_MID2  + encodeURIComponent(size) +
                    BUY_MID3  + encodeURIComponent(productUrl) +
                    BUY_END;
      url = 'https://wa.me/' + PHONE + '?text=' + encoded;
    } else {
      // Consult format (no URL)
      var encoded2 = CONSULT_START + encodeURIComponent(title) +
                     CONSULT_MID1  + encodeURIComponent(color) +
                     CONSULT_MID2  + encodeURIComponent(size) +
                     CONSULT_END;
      url = 'https://wa.me/' + PHONE + '?text=' + encoded2;
    }

    var opened = window.open(url, '_blank', 'noopener,noreferrer');
    if (!opened) window.location.href = url;
  }

  // Event delegation — handles both classes site-wide
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var buyLink = target.closest('a.vg-wa-buy, button.vg-wa-buy');
    if (buyLink) { handleClick(ev, buyLink, 'buy'); return; }
    var consultLink = target.closest('a.vg-wa-consult, button.vg-wa-consult');
    if (consultLink) { handleClick(ev, consultLink, 'consult'); return; }
  });
})();
